import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from './components/logo/logo.component';
import { TranslateModule } from '@ngx-translate/core';
import { GuestHeaderComponent } from './components/auth-header/guest-header.component';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { ServiceHeaderComponent } from '../apeco-services/shared/components/service-header/service-header.component';

@NgModule({
  declarations: [LogoComponent, GuestHeaderComponent],
  exports: [LogoComponent, GuestHeaderComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ServiceHeaderComponent,
    LanguageSwitcherComponent
  ]
})
export class SharedModule {}
